/* eslint-disable no-return-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  TextInput, Select, Form, Button,
} from 'components/common';
import { getObjectByLanguage } from 'language/helpers';
import { maxLengthValidator } from 'utils/formValidators';

const MachineAddressInformation = ({
  t, machineData, updateMachineData, sources, setCurrentStep,
}) => {
  let formRef = useRef();

  useEffect(() => {
    if (!_.isEmpty(machineData.country)) {
      formRef.setFieldsValue({
        country: machineData.country,
        region: machineData.region,
        district: machineData.district,
        postalCode: machineData.postalCode,
      });
    }
  }, []);

  const onFormSubmit = () => {
    setCurrentStep('MachineInformation');
  };

  return (
    <div className="col-md-10 col-lg-8 offset-lg-1 mt-5 mt-md-0">
      <Form
        layout="vertical"
        onFinish={onFormSubmit}
        formRef={(ref) => formRef = ref}
      >
        <div className="fs-22 mb-2">{t('stepNumber', { step: 1 })}</div>
        <div className="fs-22 fw-900 mb-3">{t('enterTheMachineAddressInformation')}</div>
        <div className="mb-5">
          İş makinanızın bulunduğu lokasyon bilgisi, potansiyel müşteriler ile paylaşılacaktır.
        </div>

        <div className="row mb-3">
          <div className="col-15 col-sm mb-3 mb-sm-0">
            <Select
              name="country"
              value={machineData.country}
              placeholder={t('country')}
              onChange={updateMachineData}
              options={
                _.map(sources.countries, (country) => {
                  return { value: country.id, text: getObjectByLanguage(country.name) };
                })
              }
              showSearch
              filterOption={(input, opt) => opt.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0}
              required
            />
          </div>
          <div className="col-15 col-sm">
            <Select
              name="region"
              value={machineData.region}
              placeholder={t('province')}
              onChange={updateMachineData}
              options={_.map(sources.regionByCountry, (region) => {
                return { value: region.id, text: getObjectByLanguage(region.name) };
              })}
              showSearch
              filterOption={(input, opt) => opt.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0}
              required
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-15 col-sm mb-3 mb-sm-0">
            <Select
              name="district"
              value={machineData.district}
              placeholder={t('district')}
              onChange={updateMachineData}
              options={_.map(sources.districtByRegion, (district) => {
                return { value: district.id, text: getObjectByLanguage(district.name) };
              })}
              showSearch
              filterOption={(input, opt) => opt.children.toLocaleLowerCase('tr').indexOf(input.toLocaleLowerCase('tr')) >= 0}
              required
            />
          </div>
          <div className="col-15 col-sm">
            <TextInput
              type="number"
              id="only-number"
              name="postalCode"
              placeholder={t('postalCode')}
              value={machineData.postalCode}
              onChange={updateMachineData}
              required
              validator={(rule, value) => maxLengthValidator(value, 5)}
            />
          </div>
        </div>

        <Button
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center mt-5 mb-5"
          label={t('next')}
        />
      </Form>
    </div>
  );
};

MachineAddressInformation.propTypes = {
  t: PropTypes.func,
  machineData: PropTypes.object,
  updateMachineData: PropTypes.func,
  sources: PropTypes.object,
  setCurrentStep: PropTypes.func,
};

export default MachineAddressInformation;
